/**
 * `5941` — *create an update with {this text, updateBody}*. Attributed to the automation owner,
 * like any other action. The one production instance uses board-qualified tokens
 * (`{1007420294.pulse.status_17}`), which is why token resolution must accept that form.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { interpolateTokens } from '../tokens.js';
import { tokenContextFor } from './token-context.js';
export const createUpdateParams = z.object({ updateBody: z.string().default('') });
export const createUpdateAction = defineAction({
    id: '5941',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'create an update with {this text, updateBody}',
    paramsSchema: createUpdateParams,
    executable: true,
    references: () => [],
    async execute(context, params) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const item = await context.services.getItem(context.itemId);
        if (item === null)
            return { skipped: 'item_deleted' };
        const tokens = await tokenContextFor(context, [params.updateBody]);
        const body = interpolateTokens(params.updateBody, tokens);
        const update = await context.services.createUpdate({ itemId: context.itemId, body });
        return { updateId: update.id, body };
    },
});
//# sourceMappingURL=5941.js.map